import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function OrderTotals({ order, translate: t, money, className }) {
    const rows = [
        { key: 'code', value: order.coupon || null },
        { key: 'delivery_price', value: money(order.deliveryPrice) },
        { key: 'tax', value: order.tax > 0 ? money(order.tax) : null },
        { key: 'points', value: order.points !== null && order.points > 0 ? `+${order.points}` : null },
    ];
    return (_jsxs("div", { className: ['opc-success-totals', className].filter(Boolean).join(' '), children: [rows
                .filter(row => row.value !== null)
                .map(row => (_jsxs("div", { className: "d-flex justify-content-between", children: [_jsx("span", { children: t(`one_page_checkout.${row.key}`) }), _jsx("span", { children: row.value })] }, row.key))), _jsxs("div", { className: "d-flex justify-content-between align-items-baseline font-weight-bold", children: [_jsx("span", { children: t('one_page_checkout.total') }), _jsx("span", { className: "font-size-body", children: money(order.total) })] })] }));
}
